"use client";
import { AuthProvider } from "@/app/common/providers/auth-provider";
import FacebookPixel from "@/app/common/providers/facebook-pixel";
import PosthogAnalyticsProvider from "@/app/common/providers/posthog-analytics-provider";
import { TalentirWagmiProvider } from "@/app/common/providers/wagmi-provider";
import { I18nProviderClient } from "@/locales/client";
import { getErrorMessage } from "@talentir/shared/helpers";
import { MutationCache, QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Provider as JotaiProvider } from "jotai";
import { toast } from "sonner";
import { ToastProvider } from "./toast-provider";
import TrpcProvider from "./trpc-provider";

const queryClient = new QueryClient({
    mutationCache: new MutationCache({
        onError: (error: unknown) => {
            const errorMessage = getErrorMessage(error);
            toast.error("Error", { description: errorMessage });
        },
    }),
});

export function TalentirProviders({ children, locale }: { children: React.ReactNode; locale: string }) {
    return (
        <>
            <I18nProviderClient locale={locale}>
                <QueryClientProvider client={queryClient}>
                    <TrpcProvider client={queryClient}>
                        <JotaiProvider>
                            <TalentirWagmiProvider>
                                <AuthProvider>
                                    <PosthogAnalyticsProvider>{children}</PosthogAnalyticsProvider>
                                </AuthProvider>
                            </TalentirWagmiProvider>
                        </JotaiProvider>
                        <ToastProvider />
                    </TrpcProvider>
                </QueryClientProvider>
            </I18nProviderClient>
            <FacebookPixel />
        </>
    );
}
